// action type strings
import * as actionTypes from '../../actionTypes';

// utilities
import _ from 'lodash';

export function updateWorksheet(worksheet, path) {
  return {
    type: actionTypes.UPDATE_WORKSHEET,
    worksheet,
    path
  };
}

export function removeWorksheet(worksheet) {
  return {
    type: actionTypes.REMOVE_WORKSHEET,
    worksheet
  };
}

// Browser data
export function getScrollBarWidth() {
  return {
    type: actionTypes.GET_SCROLLBAR_WIDTH
  };
}

// Prelim Application
export function updatePrelimForm(updateObj) {
  return _.merge(updateObj, {
    type: actionTypes.UPDATE_PRELIM_FORM
  });
}

// Applicant/Admin (any user auth)
export function updateUser(user) {
  return {
    type: actionTypes.UPDATE_USER,
    ...user
  };
}

// Applicant
export function updateApplicant(updatesObj) {
  // updates obj can include properties user, profile, workExperience...
  return {
    type: actionTypes.UPDATE_APPLICANT,
    ...updatesObj
  };
}

export function clearApplicant() {
  return {
    type: actionTypes.CLEAR_APPLICANT
  };
}

export function deleteListItem(clientId) {
  return {
    type: actionTypes.DELETE_FROM_APPLICANT_LIST,
    clientId
  };
}

// Admin
export function updateApplicantsList(applicants) {
  return {
    type: actionTypes.UPDATE_APPLICANTS_LIST,
    applicants
  };
}

// Admin
export function updateContactsList(contacts) {
  return {
    type: actionTypes.UPDATE_CONTACTS_LIST,
    contacts,
  };
}

export function updateContactsPage(data) {
  return {
    type: actionTypes.UPDATE_CONTACTS_PAGE,
    data,
  };
}

// Admin
export function updateCompaniesList(companies) {
  return {
    type: actionTypes.UPDATE_COMPANIES_LIST,
    companies
  };
}

export function updateCompaniesPage(data) {
  return {
    type: actionTypes.UPDATE_COMPANIES_PAGE,
    data,
  };
}

export function getCompanyInfo({company, groups}) {
  return {
    type: actionTypes.GET_COMPANY_INFO,
    company,
    groups
  };
}
export function updateApplicantsPage(group, data) {
  return {
    type: actionTypes.UPDATE_APPLICANTS_PAGE,
    group,
    data
  };
}

export function updateEventList(event) {
  return {
    type: actionTypes.UPDATE_EVENT_LIST,
    event
  };
}

export function updateContactEventList(contactEvent) {
  return {
    type: actionTypes.UPDATE_CONTACT_EVENT_LIST,
    contactEvent
  };
}

export function addApplicantAdmin(applicant) {
  return {
    type: actionTypes.ADD_APPLICANT_ADMIN,
    applicant
  };
}

export function deleteApplicantAdmin(applicantId, group) {
  return {
    type: actionTypes.DELETE_APPLICANT_ADMIN,
    applicantId,
    group,
  };
}

export function updateCurrentApplicantAdmin(applicant) {
  return {
    type: actionTypes.UPDATE_CURRENT_APPLICANT_ADMIN,
    applicant
  };
}

export function updateApplicantAdmin(updatedApplicant, group, arrayIndex, newGroup) {
  return {
    type: actionTypes.UPDATE_APPLICANT_ADMIN,
    group,
    arrayIndex,
    updatedApplicant,
    newGroup
  };
}

export function updateApplicantBehavioralAnswers(updatesObj) {
  return {
    type: actionTypes.UPDATE_APPLICANT_BEHAVIORAL_ANS,
    ...updatesObj
  };
}

export function updateApplicantWorkObjectives(updatesObj) {
  return {
    type: actionTypes.UPDATE_APPLICANT_WORK_OBJECTIVES,
    ...updatesObj
  };
}

export function updateApplicantInterviewRatings(updatesObj) {
  return {
    type: actionTypes.UPDATE_APPLICANT_INTERVIEW_RATINGS,
    ...updatesObj
  };
}

export function updateApplicantAssessments(updatesObj) {
  return {
    type: actionTypes.UPDATE_APPLICANT_ASSESSMENTS,
    ...updatesObj
  };
}

export function changeNavColumnState(navColumnState) {
  return {
    type: actionTypes.CHANGE_NAV_COLUMN_STATE,
    navColumnState
  };
}

export function updateApplicantAccordionData(setStr, value) {
  return {
    type: actionTypes.UPDATE_ACCORDION_DATA,
    setStr,
    value
  };
}

export function updateTempState(newTempState) {
  return {
    type: actionTypes.UPDATE_TEMP_STATE,
    newTempState
  };
}

export function updateApplicantReferencesInterviews(interview) {
  return {
    type: actionTypes.UPDATE_APPLICANT_REFERENCES_INTERVIEWS,
    interviews: interview
  };
}

export function updatePlacementSpecialists(placementSpecialists) {
  return {
    type: actionTypes.UPDATE_PLACEMENT_SPECIALISTS,
    placementSpecialists
  };
}

export function updatePinnedApplicants(applicant) {
  return {
    type: actionTypes.UPDATE_PINNED_APPLICANTS,
    applicant
  };
}

export function loadPins(pins) {
  return {
    type: actionTypes.LOAD_PINS,
    pins
  };
}

export function updateAlerts(alerts) {
  return {
    type: actionTypes.UPDATE_ALERTS,
    alerts
  };
}

export function setNavState(navState) {
  return {
    type: actionTypes.SET_NAV_STATE,
    navState
  };
}

export function updateContactsTableSearchTerms(searchTerms) {
  return {
    type: actionTypes.UPDATE_CONTACTS_TABLE_SEARCH_TERMS,
    searchTerms
  };
}

export function updateContactsTableFilters(filters) {
  return {
    type: actionTypes.UPDATE_CONTACTS_TABLE_FILTERS,
    filters
  };
}

export function updateCompaniesTableSearchTerms(searchTerms) {
  return {
    type: actionTypes.UPDATE_COMPANIES_TABLE_SEARCH_TERMS,
    searchTerms
  };
}

export function updateCompaniesTableFilters(filters) {
  return {
    type: actionTypes.UPDATE_COMPANIES_TABLE_FILTERS,
    filters
  };
}

export function updateJobRequestFilters(filters) {
  return {
    type: actionTypes.UPDATE_JOB_REQUESTS_FILTERS,
    filters
  };
}

export function updateJobRequestTerms(searchTerms) {
  return {
    type: actionTypes.UPDATE_JOB_REQUESTS_TERMS,
    searchTerms
  };
}

export function goToContactsPage(page) {
  return {
    type: actionTypes.GO_TO_CONTACTS_PAGE,
    page,
  };
}



// WEBPACK FOOTER //
// ./shared/redux/actionCreators/sync/index.js